import {
  SESSION_ACTIVITY_CONTRACT_ADDRESSES,
  SESSION_ACTIVITY_IDS,
  appConfig,
} from "@/constants";
import { usePassportProvider } from "@/context/PassportProvider";
import { useAccessToken } from "@/hooks/useAccessToken";
import { EnvironmentNames } from "@/types";
import { useCallback } from "react";
import { notifyError } from "./monitoring";
import { authorizedGet } from "./request";

type SessionActivityResponse = {
  result: {
    checked_in_at: string;
    is_pre_onboarding: boolean;
  }[];
};

export const useSessionActivity = (gameId: string) => {
  const { zkEvmProvider } = usePassportProvider();
  const getAccessToken = useAccessToken();
  const sessionActivityContractAddress =
    SESSION_ACTIVITY_CONTRACT_ADDRESSES.get(gameId);
  const sessionActivityClientId = SESSION_ACTIVITY_IDS.get(gameId);

  const trackSessionActivity = useCallback(async () => {
    // Only track session activity in production
    if (
      appConfig.ENVIRONMENT !== EnvironmentNames.PRODUCTION ||
      !zkEvmProvider ||
      !sessionActivityClientId
    ) {
      return;
    }

    const accessToken = await getAccessToken();
    if (!accessToken) {
      throw new Error("No access token");
    }

    // If we have the contract address mapped, check if the user has done any passport check-in
    if (sessionActivityContractAddress) {
      try {
        const response = await authorizedGet<SessionActivityResponse>(
          `/v1/quests/addresses/${sessionActivityContractAddress}/latest-passport-check-ins`,
          accessToken,
        );
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);

        console.log(
          "check",
          new Date(response.result[0].checked_in_at) < startOfToday,
        );
        if (
          zkEvmProvider &&
          (response.result.length === 0 ||
            new Date(response.result[0].checked_in_at) < startOfToday)
        ) {
          console.log("success check");
          await zkEvmProvider.request({
            method: "im_addSessionActivity",
            params: [sessionActivityClientId],
          });
        }
      } catch (error) {
        notifyError(error, "sessionActivity");
      }
      return;
    }

    // If we have the client ID mapped, attempt to track session activity
    if (sessionActivityClientId && zkEvmProvider) {
      await zkEvmProvider.request({
        method: "im_addSessionActivity",
        params: [sessionActivityClientId],
      });
    }
  }, [
    sessionActivityContractAddress,
    sessionActivityClientId,
    zkEvmProvider,
    getAccessToken,
  ]);

  return { trackSessionActivity };
};
